import React from 'react';
import { useSelector } from 'react-redux';

import Icon from 'dpl/common/components/Icon';

export default function PuppyCollegeBenefits() {
  const benefits = useSelector(({ server }) => server.benefits);
  const iconPosition = {
    1: 'fetch-book',
    2: 'fetch-phone',
    3: 'fetch-facebook'
  };

  return (
    <section className="PuppyCollegeBenefits pt6 pb18 pt8-md pb20-md">
      <div className="container">
        <div className="row">
          <div className="mb14-lg mb6 col-lg-9 center">
            <h2 className="md:font-40 xs:font-28 tc-l lh-title">
              {benefits.title}
            </h2>
          </div>
          <div className="mh3 nb6 nb0-lg">
            <ul className="PuppyCollegeBenefitsList">
              {benefits.page_items.map((pageItem, idx) => {
                return (
                  <li
                    className="bg-gray-100 b--gray-300 br4 pv6 ph6 ba"
                    key={idx}
                  >
                    <div className="mr0 mr4-lg ml0-lg">
                      <Icon
                        className="bg-white pv4 ph4 br-100"
                        width="64px"
                        height="64px"
                        name={iconPosition[pageItem.position]}
                      />
                    </div>
                    <div className="pr0 pr4 flex-auto">
                      <p className="font-medium md:font-24 xs:font-20 mt6">
                        {pageItem.title}
                      </p>
                      <p className="mt2 xs:font-16 md:font-18 secondary">
                        {pageItem.long_description}
                      </p>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
